import React,{useState,useEffect} from 'react'
import { Link } from 'react-router-dom'
import { getFeeStructure, getTransactionsList } from '../actions/StudentAction'
import { StateUseContext } from '../context/UserDetailContext'


const MyTransaction = () => {
    const {userDetail,feeDetail} = StateUseContext();
    const {course_name,form_num,} = userDetail !==undefined && userDetail
    const {currency_code} = feeDetail !==undefined && feeDetail

    const [transactionList,setTransactionList] = useState()
    const [feeStructureList,setFeeStructureList] = useState()
    const [loading,setLoading] = useState(true)

    useEffect(() => {
        const transactionListData = async () => {
          try {
            const res = await getTransactionsList();
            if (res.status === true) {
                setLoading(false)
                setTransactionList(res.data);
            }
          } catch (error) {
            console.log('transaction error...', error);
          }
        };

        const feeStructureListData = async () => {
            try {
              const res = await getFeeStructure();
              if (res.status === true) {
                  setLoading(false)
                  setFeeStructureList(res.data)
              }

            } catch (error) {
              console.log('transaction error...', error);
            }
          };

        if (userDetail) {
          transactionListData();
          feeStructureListData()
        }
      }, [userDetail]);


  return (
    <div className="container mt-5">
        <div className="row align-items-center">
            <div className="col-6">
                <h2 className='fs-lg-4 fs-5 fw-bold'>My Transactions</h2>
            </div>
            <div className="col-6 text-end">
                <Link to={'/student/dashboard'} className='go-to-dashLink text-secondary px-3 border-light border fw-medium py-2 bg-white shadow-sm rounded d-inline-block text-decoration-none'>Go To Dashboard</Link>
            </div>
        </div>
        <div className="row mt-3">
            <div className="col-lg-12">
            <h2 className='fs-6 fw-bold text-info border-3 mt-2 mb-2 border-start ps-2 bg-light py-2 border-info fw-semibold'>Fee Structure</h2>
            </div>
            <div className="col-lg-12 mt-0">
                <div className="table-responsive">
                <table className="table table-striped verticle-middle text-center">
                        <thead  className="table-light">
                            <tr>
                            <th className='py-3'>Installment No.</th>
                            {/* <th className='py-3'>Transaction Date</th> */}
                            <th className='py-3'>Net Payable</th>
                            <th className='py-3'>Paid Amount</th>
                            <th className='py-3'>Outstanding</th>
                            <th className='py-3'>Status</th>
                            </tr>
                        </thead>
                            {
                            loading ? 
                            <tbody>
                                <tr>
                                    <td className='text-center py-4' colSpan={5}>
                                    <div className="spinner-grow spinner-grow-sm mt-2" role="status">
                                            <span  className='visually-hidden'>Loading...</span> 
                                    </div> <span className='d-block fw-bold mt-1 ms-2'>Loading data...</span> </td>
                                </tr>
                            </tbody>
                            :
                            <tbody>
                            {feeStructureList?.length > 0 ? feeStructureList?.map((item,index) => (
                                <tr key={index}>
                                    <td>{item.installments_number} </td>
                                    {/* <td>{item.transaction_date}</td> */}
                                    <td>{item.net_payable_amount} {currency_code}</td>
                                    <td>{item.paid_amount}  {currency_code}</td>
                                    <td>{item.pending}  {currency_code}</td>
                                    <td>{item.status}</td>
                                </tr>
                            ))
                            :<tr>
                                <td className='text-center' colSpan={5}>No Data Found</td>
                            </tr>
                        
                            }
                        </tbody>
                        }
                       
                    
                </table>
                </div>
            </div>
        </div>
        <div className="row mt-3">
        <div className="col-lg-12">
            <h2 className='fs-6 fw-bold text-info border-3 mt-2 mb-2 border-start ps-2 bg-light py-2 border-info fw-semibold'>Payments</h2>
            </div>
            <div className="col-lg-12 mt-0">
                <div className="table-responsive">
                    <table className="table table-striped verticle-middle text-center" >
                        <thead className="table-light">
                            <tr>
                                <th className='py-3'>Transaction Id</th>
                                <th className='py-3'>Course Name</th>
                                <th className='py-3'>Transaction Amount</th>
                                <th className='py-3'>Transaction Date</th>
                                <th className='py-3'>Download Receipt</th>
                            </tr>
                        </thead>
                        {
                            loading ? 
                            <tbody>
                                <tr>
                                    <td className='text-center py-4' colSpan={5}>
                                    <div className="spinner-grow spinner-grow-sm mt-2" role="status">
                                            <span  className='visually-hidden'>Loading...</span> 
                                    </div> <span className='d-block fw-bold mt-1 ms-2'>Loading data...</span> </td>
                                </tr>
                            </tbody>
                            :
                            <tbody>
                            {transactionList?.length > 0 ? transactionList?.map((item,index) => (
                                <tr key={index}>
                                    <td>{item.pay_transaction_id}</td>
                                    <td>{course_name}</td>
                                    <td>{item.paid_amount}   {currency_code}</td>
                                    <td>{item.transaction_date}</td>
                                    <td>
                                      {(item.verification_status ===1 && item.acknowledgement_slip !=='') &&  
                                        <Link to={item.acknowledgement_slip} title={`${form_num}-${item.installments_number>0?`INST-${item.installments_number}`:'LUMPSUM'}.pdf`}  download={`${form_num}-${item.installments_number>0?`INST-${item.installments_number}`:'LUMPSUM'}.pdf`} target='_blank' className='btn btn-light btn-sm  border border-dark'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-download me-2" viewBox="0 0 16 16">
                                                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                            </svg> Receipt
                                        </Link>
                                        }
                                        {(item.verification_status ===1 && item.acknowledgement_slip ==='') && 'Receipt Not Generated'}
                                        {(item.verification_status ===2 && item.acknowledgement_slip ==='') && <span className='badge py-2 bg-danger-subtle text-dark'>Transaction Rejected</span>}
                                        {(item.verification_status ===0 && item.acknowledgement_slip ==='') && <span className='badge text-dark py-2 bg-warning'>Approval Pending</span>}

                                       

                                    
                                    </td>
                                </tr>
                            ))
                            :<tr>
                                <td className='text-center' colSpan={5}>No Data Found</td>
                            </tr>
                        
                            }



                        </tbody>
                        }
                        

                    </table>
                </div>
            </div>
        </div>
    </div>
  )
}

export default MyTransaction